<div
  class="alert-container"
  [class.visible]="alertService.alertVisible()"
  [class.admin-area-width]="adminArea()">
  <div [class]="snackbarClass()" class="snackbar">
    <span
      class="message font-color-black"
      [innerHTML]="alertService.alert()?.message">
    </span>
    <button (click)="closeAlert()" class="close-btn">
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>
</div>
